import React, { Component } from 'react';
import { Row, Container, Col, Button, Modal, Table, Alert } from "react-bootstrap";
import $ from 'jquery'; 

export default class AssessFNRisk extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alertDismissibleAllergiesShow: false,
        };
    }
    confirm(){
        // let assessFNFlag = false;
        // $('input[type="radio"]:checked').each(function() {
        //     if (this.value =='Y') {
        //         assessFNFlag = true;
        //        return false;
        //     }
        // });
        // if(assessFNFlag){
        //     this.props.onConfirm('Y');
        // }else{
        //     this.props.closeModal();
        //     alert('No GCSF Medication required');
        // }
        this.setState({ alertDismissibleAllergiesShow: true });
        
    }
    render() {
        const { showAssessFNRisk,closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        return (
            <Row>
            <Modal id="report" show={showAssessFNRisk} animation={true} scrollable={true} size="lg">
                <Modal.Header closeButton onClick={() => closePreviewModal()}>
                    <Modal.Title>
                        <h3 className="fs-18 header_title mb-0 text-black">Assess FN Risk</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                            <Row>
                                <Col lg='12'>
                                    <Alert variant="danger" show={this.state.alertDismissibleAllergiesShow} style={{padding: '1.5rem'}} onClick={() => this.setState({ alertDismissibleAllergiesShow: false })} dismissible>
                                        <b>Note: Please consider giving medicines for FN Risk</b>
                                    </Alert>
                                </Col>
                                <Col lg='12'>
                                    <Table responsive="lg" striped bordered>
                                        <tbody>
                                            <tr role="row" className="odd">
                                                <td><b>Prior Chemotherapy OR Radiation Therapy</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group"/> No
                                                </td>
                                            </tr>
                                            <tr role="row" className="odd">
                                                <td><b>Persistent Neutropenia</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group1" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group1"/> No
                                                </td>
                                            </tr>
                                            <tr role="row" className="odd">
                                                <td><b>Bone Marrow involvement by Tumor</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group2" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group2"/> No
                                                </td>
                                            </tr>
                                            <tr role="row" className="odd">
                                                <td><b>Recent surgery and/or Open wounds</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group3" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group3"/> No
                                                </td>
                                            </tr>
                                            <tr role="row" className="odd">
                                                <td><b>Liver Dysfunction (Billrubin &gt; 2.0)</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group4" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group4"/> No
                                                </td>
                                            </tr>
                                            <tr role="row" className="odd">
                                                <td><b>Renal Dysfunction (Creatinine Clearance &lt; 50)</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group5" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group5"/> No
                                                </td>
                                            </tr>
                                            <tr role="row" className="odd">
                                                <td><b>Age of patient is &gt; 65</b></td>
                                                <td>
                                                    <input type="radio" value="Y" name="group6" onClick={() => this.confirm()}/> Yes
                                                    <input type="radio" value="N" name="group6"/> No
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table >
                                </Col>
                            </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col lg='12' className='text-center'>
                            {/* <Button className="btn-primary btn btn-secondary" onClick={() => this.confirm()}> Confirm </Button> */}
                            <Button className="btn-primary btn btn-secondary btn-lg mr-1" onClick={() => closePreviewModal()}> OK </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        </Row>
            
        )
    }
}